import { render, staticRenderFns } from "./VaSidebar.demo.vue?vue&type=template&id=2b1058b5&"
import script from "./VaSidebar.demo.vue?vue&type=script&lang=js&"
export * from "./VaSidebar.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports